"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SpotBank = void 0;
var _react = _interopRequireDefault(require("react"));
var _SVG = require("../SVG");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const SpotBank = _ref => {
  let {
    spotColor = "#C9DBFE",
    color = "#13126C",
    strokeWidth = "2.2",
    ...props
  } = _ref;
  return /*#__PURE__*/_react.default.createElement(_SVG.SVG, _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 40 40"
  }, props), /*#__PURE__*/_react.default.createElement("path", {
    fill: spotColor,
    fillRule: "evenodd",
    d: "M17.798 6.933c-3.35.756-8.67 2.033-12.548 5.833-3.878 3.81-6.665 10.498-4.485 14.332 2.192 3.823 9.352 4.78 15.657 6.315 6.317 1.545 11.77 3.665 15.58 1.95 3.798-1.713 5.934-7.25 7.07-12.02 1.145-4.77 1.27-8.762.156-12.1-1.1-3.337-3.462-6.01-6.148-6.89-2.698-.868-5.732.046-8.127.813-2.394.766-3.795 1-7.155 1.767Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/_react.default.createElement("path", {
    stroke: color,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: strokeWidth,
    d: "M6 16.91H3.773A.77.77 0 0 1 3 16.138v-3.091c0-.272.143-.525.378-.664l15.115-8.978A3.121 3.121 0 0 1 20.01 3a3.038 3.038 0 0 1 1.496.407l15.116 8.977a.771.771 0 0 1 .378.664v3.09a.77.77 0 0 1-.773.771H34m-28 0v13.91m0-13.91h4M6 30.82c-1.705 0-3 1.386-3 3.09v2.318c0 .427.346.773.773.773h32.454a.772.772 0 0 0 .773-.773V33.91c0-1.704-1.295-3.09-3-3.09m-28 0h4m24 0v-13.91m0 13.91h-4m4-13.91h-4m0 0v13.91m0-13.91h-8m8 13.91h-8m0-13.91v13.91m0-13.91h-4m4 13.91h-4m0-13.91v13.91m0-13.91h-8m8 13.91h-8m0-13.91v13.91M22.5 10.5a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0Z"
  }));
};
exports.SpotBank = SpotBank;
SpotBank.displayName = "SpotBank";